<script>
import Layout from "@/views/layouts/main.vue";
import apiEndpoints from "@/services/apiEndpoints";
import http from "@/services/http";
import appConfig from "@/app.config.json";

export default {
  name: "DetailWork",
  page: {
    title: "サービス詳細",
    meta: [{ name: "description", content: appConfig.description }]
  },
  data() {
    return {
      isLoading: false,
      work: {
        case: {
          customer: {},
          discharger: {},
          discharger_site: {},
        },
        service_category: {
          product: {}
        },
        estimates: [{
          invoice_product_name: null,
          unit_price: null,
          unit_cost: null,
          start_date_of_application: null,
          end_date_of_application: null,
          zz_unit: {},
        }],
      }
    };
  },
  components: {
    Layout
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;

      const url = apiEndpoints.projects_sales_work_detail(this.projectId, this.workId);
      const sendApiProject = await http.get(url, {});
      const {status, data} = sendApiProject;

      if (status) {
        this.work = data.result;
      }

      this.isLoading = false;
    },
    backToList() {
      let query = (localStorage.getItem('projects/sales/work') == null)
        ? {activeTabIndex: this.$constant.pages.project.sales.work.tabIndex}
        : JSON.parse(localStorage.getItem('projects/sales/work'))
      this.$router.push({
        name: "projects.sales",
        params: {id: this.projectId},
        query: query
      });
    },
    getActivate(estimate){
      return estimate.is_activate == "1" ? "受注" : "未受注";
    }
  },
  computed: {
    projectId() {
      return this.$route.params.id;
    },
    workId() {
      return this.$route.params.work_id;
    },
  }
};
</script>
<template>
  <Layout>
    <b-container fluid>
      <div class="d-flex justify-content-end mb-2">
        <b-button variant="primary" size="lg" @click="backToList()">{{
            this.$lang.button.back
          }}
        </b-button>
      </div>
      <b-card :show="isLoading">
        <b-row>
          <div class="table-responsive">
            <table
              class="table table-hover table-borderless align-middle table-centered table-nowrap mb-0 table-striped"
            >
              <thead class="table-light">
              <tr>
                <th>SG管理番号</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>{{ work.service_cd }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </b-row>
        <b-row>
          <div class="content-block mt-3">
            <div class="title title-bg-green">商流情報</div>
            <div class="table-responsive">
              <table
                class="table table-bordered align-middle table-centered table-nowrap mb-0 table-striped"
              >
                <tbody>
                <tr>
                  <th colspan="6">商流</th>
                </tr>
                <tr>
                  <td colspan="6">
                    <span v-if="work.case">{{ work.case.case_name }}</span>
                  </td>
                </tr>
                <tr>
                  <th>得意先名</th>
                  <th>事業者</th>
                  <th>事業場</th>
                </tr>
                <tr>
                  <td>
                    <span v-if="work.case.customer">{{ work.case.customer.name }}</span>
                  </td>
                  <td>
                    <span v-if="work.case.discharger"> {{ work.case.discharger.name_abbreviated }}</span>
                  </td>
                  <td>
                    <span v-if="work.case.discharger_site"> {{ work.case.discharger_site.name_abbreviated }}</span>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </b-row>
        <b-row>
          <div class="content-block mt-3">
            <div class="title title-bg-green">サービス情報</div>
            <div class="table-responsive">
              <table
                class="table table-bordered align-middle table-centered table-nowrap mb-0 table-striped"
              >
                <tbody>
                <tr>
                  <th colspan="6">サービス名*</th>
                </tr>
                <tr>
                  <td>{{ work.name }}</td>
                </tr>
                <tr>
                  <th colspan="6">サービス種類</th>
                </tr>
                <tr>
                  <td>{{ work.service_category.name_abbreviated }}</td>
                </tr>
                <tr>
                  <th colspan="6">商品</th>
                </tr>
                <tr>
                  <td colspan="6">
                    <span v-if="work.service_category.product">{{ work.service_category.product.name }}</span>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </b-row>
        <b-row>
          <div class="content-block mt-3">
            <div class="title title-bg-green">作業見積明細</div>
            <div class="table-responsive">
              <table
                class="table table-bordered align-middle table-centered table-nowrap mb-0 table-striped"
              >
                <tbody>
                <tr>
                  <th>請求書表示用商品名</th>
                  <th>適用開始日</th>
                  <th>適用終了日</th>
                  <th>単価</th>
                  <th>単位</th>
                  <th>原単価</th>
                  <th>受注状況</th>
                </tr>
                <tr v-for="(item, index) in work.estimates" :key="index">
                  <td><span>{{ item.invoice_product_name }}</span></td>
                  <td><span>{{ item.start_date_of_application | date }} </span></td>
                  <td><span>{{ item.end_date_of_application | date }} </span><span>{{ item.end_date_of_application_2 | date }} </span><span>{{ item.end_date_of_application_3 | date }} </span></td>
                  <td class="text-end"><span>{{ item.unit_price | number }}</span><span>{{ item.unit_price_2 | number }}</span><span>{{ item.unit_price_3 | number }}</span></td>
                  <td><span v-if="item.zz_unit">{{ item.zz_unit.unit }} </span></td>
                  <td class="text-end"><span>{{ item.unit_cost | number }}</span><span>{{ item.unit_cost_2 | number }}</span><span>{{ item.unit_cost_3 | number }}</span></td>
                  <td><span>{{ getActivate(item) }}</span></td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </b-row>
      </b-card>
    </b-container>
  </Layout>

</template>
<style scoped lang="scss">
.content-block {
  .title {
    padding: 2px;
    color: #ffffff;
  }

  .title-bg-green {
    background-color: #2cb57e;
  }
}

.table-border-spacing {
  border: none;
  border-collapse: separate;
  border-spacing: 10px;
  margin: 0 -10px;
  min-width: 100%;
}
</style>
